
import './SupportCard.scss';
import { SupportCardProps } from '../types/SupportCardProps';


export default function SupportCard(
	props: SupportCardProps
) {
	return (
		<div className={'support-card'}>
			{
				props.title &&
				<div className='support-title'>
					{props.title}
				</div>
			}
			<div className='support-details'>
				{
					(props.img || props.defaultImg) &&
					<img src={props.img ?? props.defaultImg} onError={({ currentTarget }) => {
						currentTarget.onerror = null; // prevents looping
						if (props.defaultImg) {
							currentTarget.src = props.defaultImg;
						}
					}} />
				}
				<div className="support-info">
					{props.name && <div>{props.name}</div>}
					{props.email && <div><i className='dx-icon-Inscyth-MailIcon'></i>{props.email}</div>}
					{props.phone && <div><i className='dx-icon-Inscyth-CallIcon'></i>{props.phone}</div>}
				</div>
			</div>

		</div>
	);
}